import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {
    CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL,
    CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT
} from "./GoalConfiguration";
import {RADIO_BUTTON_NOT_SELECTED, RADIO_BUTTON_SELECTED, RadioButton} from "../../elements/RadioButton";
import AdAccountsItems from "../../elements/AdAccountsItems";
import {CHANNEL_INFO_BY_CHANNEL} from "../../channels/channels";
import {AccountActionsConfiguration} from "../accounts/AccountActionsConfiguration";
import { withTranslation } from 'react-i18next';


class EditMetricConversionConfigurationFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            actionIdsSelectedByBuccId: this.props.actionIdsSelectedByBuccId !== undefined && this.props.actionIdsSelectedByBuccId !== null ? this.props.actionIdsSelectedByBuccId : {},
            conversionType: this.props.conversionType
        };

        this.handleConversionTypeChange = this.handleConversionTypeChange.bind(this)
        this.handleAdAccountActionsChange = this.handleAdAccountActionsChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    handleConversionTypeChange(conversionType) {
        this.setState({
            conversionType: conversionType
        });
    }

    handleAdAccountActionsChange(buccId, actionsIds){
        const actionIdsSelectedByBuccId = this.state.actionIdsSelectedByBuccId;
        actionIdsSelectedByBuccId[buccId] = actionsIds;
        this.setState({
            actionIdsSelectedByBuccId: actionIdsSelectedByBuccId
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.afterSuccessfulEdited(this.state.conversionType, this.state.actionIdsSelectedByBuccId)
    }

    footerButton() {
        const { t } = this.props;
        return <input type="submit" value={t('client.select_button')} className="btn -submit"/>
    }

    renderAdAccountsItems() {
        if(this.state.conversionType !== CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT)
            return;

        const adAccountsSelectedItemsData = this.props.adAccountsActionData.getAdAccountsSelectedItemsData();
        return <AdAccountsItems adAccountsSelectedItemsData={adAccountsSelectedItemsData}/>
    }

    getActionsIdsSelectedOfBucc(buccId) {
        if(this.state.actionIdsSelectedByBuccId[buccId] === undefined)
            return [];

        return this.state.actionIdsSelectedByBuccId[buccId];
    }

    renderAdAccountsItemsToSelect() {
        if(this.state.conversionType !== CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL)
            return;

        // Por cada cuenta voy a mostrar el seleccionador de eventos. Cada vez que cambia, ordena el status
        const result = []
        this.props.adAccountsActionData.getAdAccountsData().forEach(adAccountData => {
            result.push(<div className={"mt-4 ad_account-actions-selector"}><AccountActionsConfiguration
                showTextWithUserIndication={false}
                showAdAccountHeader={true}
                channel={adAccountData["channel"]}
                accountId={adAccountData["ad_account_account_id"]}
                name={adAccountData["ad_account_name"]}
                selectedActions={this.getActionsIdsSelectedOfBucc(adAccountData["bucc_id"])}
                allActions={this.props.adAccountsActionData.getAllActionsOfCampaignsConfiguration(adAccountData["bucc_id"])}
                onChange={(actionsIds) => {this.handleAdAccountActionsChange(adAccountData["bucc_id"], actionsIds); }}
                hasIncludeAllConversionsSetting={CHANNEL_INFO_BY_CHANNEL[adAccountData["channel"]]["hasIncludeAllConversionsSetting"]}
            /></div>);
        });

        return result;
    }

    render() {

        const typeBusinessUnitActionRadioButtonStatus = this.state.conversionType === CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT ? RADIO_BUTTON_SELECTED : RADIO_BUTTON_NOT_SELECTED;
        const typeSelectActionsRadioButtonStatus = this.state.conversionType === CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL ? RADIO_BUTTON_SELECTED : RADIO_BUTTON_NOT_SELECTED;

        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <div className="col-12 d-flex align-items-start">
                                <RadioButton status={typeBusinessUnitActionRadioButtonStatus} onActivation={() => {
                                    this.handleConversionTypeChange(CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT);
                                }}/>
                                <div className="ml-2 mt-2">
                                    {this.props.t('edit_metric_conversion_form.use_same_events')}
                                    {this.renderAdAccountsItems()}
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-12 d-flex align-items-start">
                                <RadioButton status={typeSelectActionsRadioButtonStatus} onActivation={() => {
                                    this.handleConversionTypeChange(CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL);
                                }}/>
                                <div className="ml-2 mt-2 multiple-ad_accounts-actions-selector">
                                    {this.props.t('edit_metric_conversion_form.select_specific_events')}
                                    {this.renderAdAccountsItemsToSelect()}
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }
}

export const EditMetricConversionConfigurationForm = withTranslation()(EditMetricConversionConfigurationFormComponent);
